import Analytics from '@wetransfer/transfer/modules/analytics';

import {
  DEVICE_NOT_RECOGNISED_EVENT,
  NEW_DOWNLOAD_LINK_REQUESTED_EVENT,
} from './tracking-constants';

export const trackPaidTransferDeviceUnrecognised = (): void => {
  Analytics.trackAmplitude(DEVICE_NOT_RECOGNISED_EVENT);
};

export const trackPaidTransferNewLinkRequested = (): void => {
  Analytics.trackAmplitude(NEW_DOWNLOAD_LINK_REQUESTED_EVENT);
};
